import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";

import {
  Influencer,
  SocialMedia,
  SocialMediaInfluencer,
} from "@shared/lib/types/influencer";
import { InfluencerService } from "../services/influencer.service";
import {
  INFLUENCER_LIST_QUERY_KEY,
  SOCIAL_MEDIA_INFLUENCER_QUERY_KEY,
} from "../constants";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "@entities/brief/lib/constants";

export function useLinkSocialMediaToInfluencer(
  handleUpdate?: (influencer: Influencer) => void
) {
  const {
    mutate: linkSocialMediaInfluencer,
    isLoading: isLinking,
    isSuccess: isLinked,
  } = useMutation<
    { socialMediaObjectId: string; influencerId: string },
    BackednResponse<SocialMediaInfluencer> | void
  >({
    mutationFn: async ({ influencerId, socialMediaObjectId }) => {
      return await InfluencerService.linkSocialMediaToInfluencer({
        influencerId,
        socialMediaObjectId,
      }).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: {
      queryKey: INFLUENCER_LIST_QUERY_KEY,
      skipInvalidation: false,
    },
    onSuccess: (c, data, { influencerId, socialMediaObjectId }) => {
      c.invalidateQueries({
        queryKey: [...SOCIAL_MEDIA_INFLUENCER_QUERY_KEY, influencerId],
      });
      c.invalidateQueries({
        queryKey: [...INFLUENCER_LIST_QUERY_KEY, influencerId],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });
      // if (data?.data) {
      //   handleUpdate?.(data.data);
      // }
    },
  });

  return {
    linkSocialMediaInfluencer,
    isLinking,
    isLinked,
  };
}
